export default __webpack_public_path__ + "static/media/Yurt3.33fb7b98.jpg";